import { useEffect, RefObject } from 'react';

/**
 * Reset a scroll container to the top whenever the tracked step changes.
 *
 * Caller owns the ref: declare it with `useRef<HTMLDivElement>(null)`,
 * attach it to the wizard's inner scrollable body (typically the
 * `<div className="px-6 py-6 overflow-y-auto">` shell), and pass it in.
 *
 * Without this, users landing on a new wizard step inherit the previous
 * step's scroll position — often deep in the page — and have to scroll
 * up to see the new content.
 */
export function useResetScrollOnStepChange(
  currentStep: number,
  ref: RefObject<HTMLElement | null>,
): void {
  useEffect(() => {
    if (ref.current) {
      ref.current.scrollTop = 0;
    }
  }, [currentStep, ref]);
}
